import React from "react";
import { useTranslation } from "react-i18next";
import { ContentCard } from "../../components/ContentCard";
import { SettingsRow } from "./SettingsRow";
import { Toggle } from "../../components/form/toggle/Toggle";
import { useOrganization } from "../../hooks/organization.hooks";
import { useMutation, useQueryClient } from "react-query";
import { setOrganizationTransactionsRetention } from "../../api/api";
import { showToastError, showToastSuccess } from "common/toast/toast";
import { Organization } from "../../types/api.types";
import { getEndingByCountLT4 } from "common/helpers/text.helpers";
import { OrganizationProfileForm } from "./OrganizationProfileForm";
import { TransactionsRetentionSettings } from "./TransactionsRetentionSettings";
import { FilesRetentionSettings } from "./FilesRetentionSettings";
import { ConfirmationDialog } from "../../components/dialogs/ConfirmationDialog";
import { LeadFlowEnabledSettings } from "./LeadFlowEnabledSettings";
import { ReloOrganizationSettings } from "./ReloOrganizationSettings";

interface OrganizationSettingsRouteProps {}

export const OrganizationSettingsRoute: React.FC<
  OrganizationSettingsRouteProps
> = () => {
  const { t } = useTranslation();
  const { data } = useOrganization();

  if (!data) {
    return null;
  }

  return (
    <>
      <ContentCard title={t("organizationSettings.title")}>
        <SettingsRow label={t("organizationSettings.rcEndUser")}>
          {!!data.RC_EndUserInfo &&
            Object.entries(data.RC_EndUserInfo).map(([key, value]) => (
              <div key={key}>
                <b>{key}</b>: {value}
              </div>
            ))}
        </SettingsRow>
        <div style={{ height: "30px" }} />
        <SettingsRow
          label={t("organizationSettings.transactionRetentionPeriod")}
        >
          <TransactionsRetentionSettings organization={data} />
        </SettingsRow>
        <div style={{ height: "30px" }} />
        <SettingsRow label={t("organizationSettings.filesRetention")}>
          <FilesRetentionSettings organization={data} />
        </SettingsRow>
        <div style={{ height: "30px" }} />
        <SettingsRow label={t("organizationSettings.leadFlowEnabled.label")}>
          <LeadFlowEnabledSettings organization={data} />
        </SettingsRow>
        <div style={{ height: "30px" }} />
        <SettingsRow label={t("organizationSettings.reloAppraiser.label")}>
          <ReloOrganizationSettings organization={data} />
        </SettingsRow>
        <div style={{ marginTop: "50px" }} />
      </ContentCard>
      <OrganizationProfileForm />
    </>
  );
};
